module.exports = __webpack_public_path__ + "img/lim guan eng_eyes.bc2f2244.jpg";